import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiPatchOrder } from '@/payment/api'
import type { PatchOrderBody } from '@/payment/types'

import { PAYMENT_KEYS } from '../keys'

interface PatchOrderArgs {
  orderId: number
  body: PatchOrderBody
}

export const usePatchOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ orderId, body }: PatchOrderArgs) => apiPatchOrder(orderId, body),
    onSuccess: (_, { orderId }) => {
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.ORDERS] })
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.ORDER_DETAIL, orderId] })
      // useSealedVinylEntry 가 SEALED_ORDER_DETAIL 캐시 사용 — 수량 변경 후 detail 재조회 필요
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.SEALED_ORDER_DETAIL] })
    },
  })
}
